import { render, staticRenderFns } from "./PrincipalPage.vue?vue&type=template&id=da3abdac&scoped=true"
import script from "./PrincipalPage.vue?vue&type=script&lang=js"
export * from "./PrincipalPage.vue?vue&type=script&lang=js"
import style0 from "./PrincipalPage.vue?vue&type=style&index=0&id=da3abdac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3abdac",
  null
  
)

export default component.exports